import { gql } from '@apollo/client';

export const GET_CURRENT_USER_PAYMENTS = gql`
  query CurrentUserPayments($first: Int = 15, $after: String) {
    currentUserPayments(first: $first, after: $after) {
      totalCount
      nodes {
        paymentLegacyId
        serviceId
        displayServiceName
        amount
        paymentMethod
        updatedAt
        originalPayment {
          displayServiceName
          paymentMethod
          rrn
          ad {
            legacyResourceId
          }
        }
        ad {
          id
          legacyResourceId
          title
          path
          price
          photo {
            url
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_CURRENT_USER_TRANSACTIONS = gql`
  query CurrentUserTransactions($first: Int = 15, $after: String) {
    currentUserTransactions(first: $first, after: $after) {
      totalCount
      nodes {
        paymentLegacyId
        serviceId
        displayServiceName
        amount
        paymentMethod
        createdAt
        ad {
          id
          legacyResourceId
          title
          path
          price
          photo {
            url
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
